/** Support access and platform announcements in the merchant Admin (docs/specs/super-admin.md SA-16, SA-19). */
export const support = {
    title: "Support access",
    description: "Let the Sobthik support team into this business for a while, for example to help with an import. Everything they do is logged.",
    grant: "Give support access",
    hours: "For how long",
    hoursOption_one: "{{hours}} hour",
    hoursOption_other: "{{hours}} hours",
    note: "What do you need help with? (optional)",
    granted: "Support can sign in until {{date}}.",
    revoke: "End access now",
    revoked: "Support access ended.",
    history: "Earlier access",
    empty: "You have not given support access.",
    active: "Active until {{date}}",
    ended: "Ended {{date}}",
    expired: "Expired {{date}}",
    banner: "Sobthik support can sign in to this business until {{date}}.",
    manage: "Manage",
    signIn: {
        title: "Support sign-in",
        body: "For the Sobthik support team: paste the support token from the Super Admin. It works only while the owner's access is open.",
        token: "Support token",
        submit: "Open the business",
    },
    dismiss: "Dismiss",
};
//# sourceMappingURL=support.js.map